import { render, staticRenderFns } from "./PlainTemplate.vue?vue&type=template&id=c4d459e4"
import script from "./PlainTemplate.vue?vue&type=script&lang=ts"
export * from "./PlainTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d459e4')) {
      api.createRecord('c4d459e4', component.options)
    } else {
      api.reload('c4d459e4', component.options)
    }
    module.hot.accept("./PlainTemplate.vue?vue&type=template&id=c4d459e4", function () {
      api.rerender('c4d459e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/PlainTemplate.vue"
export default component.exports